(function importProcessControllerDefinition() {
    'use strict';

    angular.module('ImportProcess')
        .controller('ImportProcessFindController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'importProcessService', 'authExtend', 'storageService', 'documentTypeService', 'containerTypeService', 'importStateService',
    function importProcessController($scope, config, $state, $translate, errors, importProcessService, authExtend, storageService, documentTypeService, containerTypeService, importStateService) {
        $scope.load = function () {
            $scope.accesAddIn = authExtend.isInRole('IMPORTPROCESS WRITE') && authExtend.getOrganizationId() !== '';
            $scope.addOptions = $scope.accesAddIn;

            $scope.orders = [
                   { value: 'LastModifiedDate ASC', description: 'LastModifiedDate ASC' },
                   { value: 'LastModifiedDate DESC', description: 'LastModifiedDate DESC' },
                   { value: 'Name ASC', description: 'Name ASC' },
                   { value: 'Name DESC', description: 'Name DESC' }
            ];

            $scope.order = $scope.orders[1];

            $scope.find = {
                dateFrom: null,
                dateTo: null,
                showNoData: false,
                selectedImportState: null,
                documentType: null,
                containerType: null
            };

            $scope.type = 1;
            $scope.importProcessDescriptionHeader = 'ImportProcessDocumentType';
            $scope.item = { id: null, name: "Todos" };

            $scope.importProcess = {
                type: 'Documents',
                typeId: 0
            };

            $scope.data = {
                currentPage: 1,
                totalItems: 0,
                itemsPerPage: 15,
                from: 0
            };

            $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                .then(function (translated) {
                    $scope.paginatorTranslations = {
                        nextText: translated.PaginationNext,
                        previousText: translated.PaginationPrev,
                        lastText: translated.PaginationLastFem,
                        firstText: translated.PaginationFirstFem
                    };
                });

            documentTypeService.getFunctionsTypes(['IMPORTPROCESS READ', 'IMPORTPROCESS WRITE'])
                .then(function (result) {
                    $scope.optionsDocumentTypes = result.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });
                    result.splice(0, 0, $scope.item);
                    $scope.find.documentType = $scope.optionsDocumentTypes[0];
                }, function (error) {
                    errors.showError(error);
                });

            importStateService.get().then(function (result) {
                result.splice(0, 0, $scope.item);
                $scope.optionsStates = result;
                $scope.find.selectedImportState = $scope.optionsStates[0];
            }, function (error) {
                errors.showError(error);
            });

            containerTypeService.getFunctionsTypes(['IMPORTPROCESS READ', 'IMPORTPROCESS WRITE']).then(function (result) {
                $scope.optionsContainerTypes = result.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
                result.splice(0, 0, $scope.item);
                $scope.find.containerType = $scope.optionsContainerTypes[0];
            }, function (error) {
                errors.showError(error);
            });

            $scope.add = function () {
                $state.go('import-process-add');
            };

            $scope.hideAddBtn = !authExtend.isInRole('IMPORTPROCESS WRITE');
        }

        $scope.$watch('importProcess.type', function (newValue, oldValue) {
            if (newValue == 'Containers')
                $scope.type = 2;
            else if (newValue == 'Documents')
                $scope.type = 1;
        });

        $scope.findAction = function () {
            $scope.items = [];
            $scope.find.showNoData = false;

            if ($scope.importProcess.type == 'Documents' && $scope.find.documentType) {
                $scope.importProcess.typeId = $scope.find.documentType.id;
            }

            if ($scope.importProcess.type == 'Containers' && $scope.find.containerType) {
                $scope.importProcess.typeId = $scope.find.containerType.id;
            }

            return importProcessService.get($scope.find.selectedImportState, $scope.find.dateFrom, $scope.find.dateTo, $scope.importProcess.typeId, $scope.type, $scope.data.currentPage, $scope.data.itemsPerPage, $scope.order.value).then(function getOk(result) {
                $scope.items = result.value;
                $scope.importProcessDescriptionHeader = $scope.importProcess.type == 'Containers' ? 'ImportProcessDocumentContainer' : 'ImportProcessDocumentType';

                $scope.data.totalItems = result.totalCount;
                $scope.data.from = result.from;

                if ($scope.items.length === 0)
                    $scope.find.showNoData = true;

                if ($scope.items.length === 0)
                    $scope.find.showNoData = true;

            }, function getError(error) {
                errors.showError(error);
            });
        };

        $scope.downloadErrorFile = function (document) {
            return importProcessService.downloadErrorFiles(document);
        };

        $scope.view = function (document) {
            $state.go('import-process-detail', { id: document.id });
        };

        $scope.load();
    }
        ]);
})();